import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { CostComponent } from '@core/components/cost/cost.component';
import { AffiliatesTier } from '../interfaces/affiliates-tiers.interface';
import {
  AFFILIATES_DEFAULT_TIER,
  AFFILIATES_TIER_META,
  affiliatesTierColorVar,
  affiliatesTierIconBlur,
} from '../configs/affiliates-tiers.config';

@Component({
  selector: 'app-affiliates-tier-card',
  imports: [SvgIconComponent, CostComponent],
  templateUrl: './affiliates-tier-card.component.html',
  styleUrl: './affiliates-tier-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    '[style.--affiliates-card-color]': 'color()',
    '[style.--affiliates-card-text-color]': 'tierColor()',
    '[style.--affiliates-card-bg-color]': 'bgColor()',
    '[class.active]': 'isActive()',
  },
})
export class AffiliatesTierCardComponent {
  color = input<string>('var(--green)');
  isActive = input<boolean>(false);
  tier = input.required<AffiliatesTier>();

  /** Tiers from `tiersResource` are already transformed; fall back for raw BE tiers. */
  private readonly meta = computed(() => {
    const t = this.tier();
    const fallback = AFFILIATES_TIER_META[t.fe_tier ?? AFFILIATES_DEFAULT_TIER];
    return {
      name: t.fe_tier_name ?? fallback.name,
      slug: t.fe_tier_slug ?? fallback.slug,
    };
  });

  tierName = computed(() => this.meta().name);

  iconBlur = computed(() => affiliatesTierIconBlur(this.meta().slug));

  tierColor = computed(() =>
    affiliatesTierColorVar(this.meta().slug, '-typography')
  );

  bgColor = computed(() =>
    affiliatesTierColorVar(this.meta().slug, '-typography-10')
  );
}
